import { Fragment } from "react"
import { Header } from "../../shared/components/Header"

export const BlogDetails: React.FC = () => {
    return (
        <Fragment>
            <Header title='Detalle del fibro consejo' />
        </Fragment>
    )
}